
const messages = {
  en: {
    modelo: {
      title: 'Modelo management',
      menuTitle: 'Models',
      subtitle: 'View, search, create, edit and delete Modelo',
      creating: 'Creating Modelo',
      editing: 'Editing Modelo',
      deleting: 'Deleting Modelo',
      showing: 'Showing Modelo',
      labels: {
        nombre: 'name',
        marca: 'marca'
      },
      modals: {
        updateImpact: {
          title: 'Confirm update',
          description: 'Updating this model will affect {productosCount} products in {depositosCount} deposits.',
          confirmQuestion: 'Do you want to continue?',
        },
        deleteImpact: {
          title: 'Confirm delete',
          description: 'Deleting this model will unlink {productosCount} products in {depositosCount} deposits.',
          confirmQuestion: 'Do you want to continue?',
        },
      },
    }
  },
  es: {
    modelo: {
      title: 'Administración de Modelo',
      menuTitle: 'Modelos',
      subtitle: 'Ver, buscar, crear, editar, y borrar Modelo',
      creating: 'Creando Modelo',
      editing: 'Modificando Modelo',
      deleting: 'Eliminando Modelo',
      showing: 'Detalles de Modelo',
      labels: {
        nombre: 'nombre',
        marca: 'marca'
      },
      modals: {
        updateImpact: {
          title: 'Confirmar actualización',
          description: 'Actualizar este modelo afectará {productosCount} productos en {depositosCount} depósitos.',
          confirmQuestion: '¿Desea continuar?',
        },
        deleteImpact: {
          title: 'Confirmar eliminación',
          description: 'Eliminar este modelo desvinculará {productosCount} productos en {depositosCount} depósitos.',
          confirmQuestion: '¿Desea continuar?',
        },
      },
    }
  },
  pt: {
    modelo: {
      title: 'Administração de Modelo',
      menuTitle: 'Modelos',
      subtitle: 'Ver, buscar, criar, editar e usar Modelo',
      creating: 'Criando Modelo',
      editing: 'Edição Modelo',
      deleting: 'Apagando Modelo',
      showing: 'Detalhes do Modelo',
      labels: {
        nombre: 'nome',
        marca: 'marca'
      },
      modals: {
        updateImpact: {
          title: 'Confirmar atualização',
          description: 'Atualizar este modelo afetará {productosCount} produtos em {depositosCount} depósitos.',
          confirmQuestion: 'Deseja continuar?',
        },
        deleteImpact: {
          title: 'Confirmar exclusão',
          description: 'Excluir este modelo desvinculará {productosCount} produtos em {depositosCount} depósitos.',
          confirmQuestion: 'Deseja continuar?',
        },
      },
    }
  }
}

export default messages
